import { referentialApiConnector } from 'apiConnector/secondary-market/referentialApiConnector';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import { liveKycActions } from 'state/secondaryMarket/live/kyc/kyc.actions';
import type { EpicWithThunk } from 'state/state.common';

import { getTabRemoved$ } from '../utils';

export function fetchKycStatusEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient, selectors: { isFeatureEnabled } }) => {
    const { getKycStatus } = referentialApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_KYC_STATUS_REQUESTED'),
      withLatestFrom(state$),
      filter(([, state]) => !isFeatureEnabled(state, 'HideKYCDisplayParis')),
      mergeMap(([{ tabId, clientBdrId, salesCountry }]) => {
        return getKycStatus(clientBdrId, salesCountry).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(data => liveKycActions.secondaryMarketKycStatusReceived(tabId, data)),
          catchError((_: Error) => {
            return of(liveKycActions.secondaryMarketKycStatusFailed(tabId));
          }),
        );
      }),
    );
  };
}
